//here we are importing our Axios dependency
import axios from 'axios';
import Global from '../../global';
import { setAxiosInterceptors } from '../../utils/axios/axios-interceptors';

//here is where we are defining our custom axios instance.
//if all of your API routes come from the same location, or you are using a web proxy to hit the server, you can provide a base url
//you can also attach axios interceptors to custom axios instances as well

function init() {
  let uid = uid = typeof window !== 'undefined' ? window.sc_logger_uid : null;
  const Agent = require('agentkeepalive');
  const { HttpsAgent } = require('agentkeepalive');
  const keepaliveHttpAgent = new Agent();
  const keepaliveHttpsAgent = new HttpsAgent();
  const axiosInstance = axios.create({
    baseURL: Global.config.clientExternalUrl,
    headers: {
      common: {
        uid: uid
      }
    },
    timeout: Global.config.axiosTimeout,
    httpAgent: keepaliveHttpAgent,
    httpsAgent: keepaliveHttpsAgent
  });
  setAxiosInterceptors(axiosInstance);

  return axiosInstance;
}


const AxiosInstance = (function () {
  let instance;

  return {
    get: function () {
      if (!instance) {
        instance = init();
      }
      return instance;
    },
  };

})();
export default AxiosInstance;
